import React from 'react'
import {Route, Switch} from 'react-router-dom'

import {asyncComponent} from '../HOC'
import * as URLS from '../../urls'

export const ProductDetail = asyncComponent(() =>
  import('./ProductDetail' /* webpackChunkName: "product-detail" */),
)
export const ProductPageContainer = asyncComponent(() =>
  import('../../containers/ProductPageContainer' /* webpackChunkName: "product-container" */),
)

const ProductMain = () => (
  <div className="product-main-wrapper">
    <Switch>
      {/* HTO Path - these functionally do nothing aside from ensure they get rendered here, not fe-core */}

      <Route
        path={URLS.PRODUCT_CATEGORY_BUY}
        render={() => <ProductPageContainer showBuyPathExperiment />}
      />
      <Route
        path={URLS.PRODUCT_CATEGORY_HTO}
        render={() => <ProductPageContainer isHtoPath nonIndexableAndNoFollow />}
      />
      <Route path={URLS.ADD_ITEMS_PRODUCT_DETAIL} render={() => <ProductDetail isAddItemsFlow />} />

      {/* Fallbacks */}
      <Route render={() => <ProductPageContainer />} />
    </Switch>
  </div>
)

export default ProductMain
